const styleSheet = () => ({
  cell: {
    // flexGrow: (props: any) => (props.flex ? props.flex : 1)
    visibility: (props: any) =>
      props.visibility ? props.visibility : 'visible',
    width: (props: any) => (props.width ? props.width : 'auto'),
    minWidth: (props: any) => (props.minWidth ? props.minWidth : '0'),
    maxWidth: (props: any) => (props.minWidth ? props.minWidth : 'none'),
    marginLeft: (props: any) => (props.marginLeft ? props.marginLeft : '0px'),
    marginRight: (props: any) =>
      props.marginRight ? props.marginRight : '0px',
    paddingRight: (props: any) =>
      props.paddingRight ? props.paddingRight : '0px',
    paddingLeft: (props: any) =>
      props.paddingLeft ? props.paddingLeft : '0px',
    paddingTop: (props: any) => (props.paddingTop ? props.paddingTop : '0px'),
    paddingBottom: (props: any) =>
      props.paddingBottom ? props.paddingBottom : '0px',
    position: (props: any) => (props.position ? props.position : 'static'),
    display: (props: any) => props.display && props.display,
    overflow: (props: any) => props.overflow && props.overflow,
  },
  caret: {
    marginLeft: '5px',
    display: 'inline-block',
    position: 'absolute',
    // Handle the caret animation increase/decrease speed by changing the 0.3s value
    transition: 'transform 0.3s ease',
  },
  caretRotateDown: {
    // Handle the caret animation
    transform: 'rotate(-180deg)',
  },
  headerCell: {
    outline: 'none',
    border: 'none',
    backgroundColor: 'inherit',
    textAlign: 'left !important',
    textTransform: 'uppercase',
    color: '#6373A4',
    fontSize: '12px',
    '&:focus': {
      outline: 'dotted 1px gray',
    },
  },
});

export default styleSheet;
